import type { ComponentType } from 'preact';
import type { IllustrationKey, IllustrationProps } from './types';
import WalkingEasyIllustration from './WalkingEasyIllustration';
import WalkingTiredIllustration from './WalkingTiredIllustration';
import WalkingImpossibleIllustration from './WalkingImpossibleIllustration';
import CarEasyIllustration from './CarEasyIllustration';
import CarStruggleIllustration from './CarStruggleIllustration';
import CarImpossibleIllustration from './CarImpossibleIllustration';
import TractorEasyIllustration from './TractorEasyIllustration';
import TractorStruggleIllustration from './TractorStruggleIllustration';
import TractorImpossibleIllustration from './TractorImpossibleIllustration';

export type { IllustrationKey, IllustrationProps, SlopeDifficulty, SlopeMode } from './types';
export { ILLUSTRATION_PALETTE } from './shared';
export { getIllustrationKeyForMode, getPrimaryIllustrationKey } from './slopeIllustrationHelpers';

const ILLUSTRATION_MAP: Record<IllustrationKey, ComponentType<IllustrationProps>> = {
  walking_easy: WalkingEasyIllustration,
  walking_struggle: WalkingTiredIllustration,
  walking_impossible: WalkingImpossibleIllustration,
  car_easy: CarEasyIllustration,
  car_struggle: CarStruggleIllustration,
  car_impossible: CarImpossibleIllustration,
  tractor_easy: TractorEasyIllustration,
  tractor_struggle: TractorStruggleIllustration,
  tractor_impossible: TractorImpossibleIllustration,
};

export function getIllustrationComponent(key: IllustrationKey): ComponentType<IllustrationProps> {
  return ILLUSTRATION_MAP[key] ?? WalkingEasyIllustration;
}

export {
  WalkingEasyIllustration,
  WalkingTiredIllustration,
  WalkingImpossibleIllustration,
  CarEasyIllustration,
  CarStruggleIllustration,
  CarImpossibleIllustration,
  TractorEasyIllustration,
  TractorStruggleIllustration,
  TractorImpossibleIllustration,
};
